<template>
  <v-snackbar
    v-model="active"
    :top="true"
    color="success"
    :timeout="6000"
  >
    {{msg}}
    <v-btn
      text
      @click="closeAlert"
    >
      {{$t('newsletter.close')}}
    </v-btn>
  </v-snackbar>
</template>

<script>
export default {
  name: 'Alert',
  props: ['active', 'msg', 'type'],
  methods: {
    closeAlert () {
      this.$emit('onClose')
    }
  }
}
</script>
